module.exports = __webpack_public_path__ + "statics/img/ddmc.jpg";